import React from 'react';
import { Check, Flame, Lock, ShieldCheck, Clock } from 'lucide-react';
import { Button, Tag } from '../ui/Shared';
import { useCountdown } from '../../hooks/useCountdown';
export function FinalCtaSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section id="cta-final" className="py-28 text-center relative overflow-hidden bg-[radial-gradient(ellipse_at_center,#1A2340,#0A0F1E)]" data-id="element-143">
      {/* Background overlay */}
      <div className="absolute inset-0 opacity-[0.03] bg-center bg-cover" style={{
      backgroundImage: "url('https://images.unsplash.com/photo-1493894473891-10fc1e5dbd22?w=800&q=60')"
    }} data-id="element-144" />

      <div className="max-w-[780px] mx-auto px-6 relative z-10" data-id="element-145">
        <Tag data-id="element-146">Última oportunidad</Tag>

        <h2 className="font-playfair text-3xl md:text-5xl lg:text-[56px] font-black mb-5 leading-[1.2]" data-id="element-147">
          No se trata de comprar otro producto.
          <br data-id="element-148" />
          <span className="text-gradient-gold text-[0.7em] leading-tight block mt-2" data-id="element-149">
            Se trata de decidir que tu cuerpo no merece seguir viviendo con
            fuego por dentro.
          </span>
        </h2>

        <p className="text-lg text-text-muted max-w-[600px] mx-auto mb-10 leading-relaxed" data-id="element-150">
          Empieza ahora. Accede a Reflujo Cero en 72h y dale a tu cuerpo la
          oportunidad de recuperarse.
        </p>

        <div className="scale-in bg-accent/10 border border-accent/20 rounded-xl p-7 md:px-6 max-w-[520px] mx-auto mb-9 text-left" data-id="element-151">
          <p className="text-sm text-text-muted mb-4 font-semibold uppercase tracking-widest" data-id="element-152">
            Lo que recibes hoy:
          </p>

          <div className="flex flex-col gap-2" data-id="element-153">
            <div className="flex gap-2.5 text-sm text-text-muted" data-id="element-154">
              <Check className="w-4 h-4 text-accent mt-0.5 shrink-0" data-id="element-155" />
              <span data-id="element-156">
                <strong className="text-text-light" data-id="element-157">Reflujo Cero en 72h</strong>
              </span>
            </div>
            <div className="flex gap-2.5 text-sm text-text-muted" data-id="element-158">
              <Check className="w-4 h-4 text-accent mt-0.5 shrink-0" data-id="element-159" />
              <span data-id="element-160">
                <strong className="text-text-light" data-id="element-161">Bono #1:</strong> Lista
                Negra del Reflujo
              </span>
            </div>
            <div className="flex gap-2.5 text-sm text-text-muted" data-id="element-162">
              <Check className="w-4 h-4 text-accent mt-0.5 shrink-0" data-id="element-163" />
              <span data-id="element-164">
                <strong className="text-text-light" data-id="element-165">Bono #2:</strong> Guía de
                Cena Sin Castigo
              </span>
            </div>
            <div className="flex gap-2.5 text-sm text-text-muted" data-id="element-166">
              <Check className="w-4 h-4 text-accent mt-0.5 shrink-0" data-id="element-167" />
              <span data-id="element-168">
                <strong className="text-text-light" data-id="element-169">Bono #3:</strong> Protocolo
                Anti-Agrura
              </span>
            </div>
            <div className="flex gap-2.5 text-sm text-text-muted" data-id="element-170">
              <Check className="w-4 h-4 text-accent mt-0.5 shrink-0" data-id="element-171" />
              <span data-id="element-172">
                <strong className="text-text-light" data-id="element-173">Garantía de 7 días</strong>{' '}
                sin preguntas
              </span>
            </div>
          </div>

          <div className="border-t border-white/10 mt-4 pt-4 flex justify-between items-center" data-id="element-174">
            <span className="text-[13px] text-text-muted" data-id="element-175">
              Valor total real:
            </span>
            <span className="price-struck text-[17px] font-bold" data-id="element-176">187 USD</span>
          </div>

          <div className="flex justify-between items-center mt-2" data-id="element-177">
            <span className="text-sm font-bold text-accent" data-id="element-178">
              Precio Especial:
            </span>
            <span className="price-glow font-playfair text-[38px] font-black text-gradient-gold leading-none" data-id="element-179">
              12 USD
            </span>
          </div>
        </div>

        <div className="flex flex-col items-center gap-2 mb-6" data-id="element-180">
          <div className="flex items-center gap-2 text-sm text-[#FC8181] font-semibold mb-2" data-id="element-181">
            <Clock className="w-4 h-4" data-id="element-182" />
            <span data-id="element-183">Tu acceso especial expira en:</span>
          </div>
          <div className="flex gap-2 font-playfair text-3xl font-black text-danger mb-2" data-id="element-184">
            <div className="bg-danger/20 rounded px-3 py-1 min-w-[3.5rem]" data-id="element-185">
              {hours}
            </div>
            <span data-id="element-186">:</span>
            <div className="bg-danger/20 rounded px-3 py-1 min-w-[3.5rem]" data-id="element-187">
              {minutes}
            </div>
            <span data-id="element-188">:</span>
            <div className="bg-danger/20 rounded px-3 py-1 min-w-[3.5rem]" data-id="element-189">
              {seconds}
            </div>
          </div>
        </div>

        <div className="flex justify-center" data-id="element-190">
          <Button href="https://pay.hotmart.com/S104868471X" size="large" data-id="element-191">
            <Flame className="w-5 h-5" data-id="element-192" />
            ¡Sí, Quiero Apagar el Fuego Ahora!
          </Button>
        </div>

        <div className="flex items-center justify-center gap-6 mt-6 flex-wrap" data-id="element-193">
          <span className="flex items-center gap-1.5 text-text-muted text-xs font-medium" data-id="element-194">
            <Lock className="w-3.5 h-3.5 text-accent" data-id="element-195" /> Compra 100% Segura
          </span>
          <span className="flex items-center gap-1.5 text-text-muted text-xs font-medium" data-id="element-196">
            <Check className="w-3.5 h-3.5 text-accent" data-id="element-197" /> Garantía 7 Días
          </span>
          <span className="flex items-center gap-1.5 text-text-muted text-xs font-medium" data-id="element-198">
            <ShieldCheck className="w-3.5 h-3.5 text-accent" data-id="element-199" /> Privacidad
            Protegida
          </span>
        </div>

        <p className="mt-6 text-sm text-text-muted flex items-center justify-center gap-2" data-id="element-200">
          <ShieldCheck className="w-4 h-4 text-accent" data-id="element-201" />7 días de garantía
          completa — Si no es lo que esperabas, te devolvemos tu dinero. Sin
          preguntas.
        </p>
      </div>
    </section>;
}